const s = {
  name: "NorwegianKrone",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,11h2v13.2l5.2-5.2H21l-5,5l5,5h-2.8l-3.6-3.6L13,27v2h-2V11z"/>
		<path class="st0" d="M23,19v10h2v-5c0-1.7,1.3-3,3-3h1v-2h-1c-1.1,0-2.2,0.4-3,1v-1H23z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as NorwegianKrone
};
